exports.authenticationEnabled = window.flow_config.authenticationEnabled;
exports.oidc = window.flow_config.oidc;
exports.theming = window.flow_config.theming;
